import React, { useState, useContext } from 'react';
import './Forms.css';
import { validateNumberInput, showToast } from '../../utils/utils';
import { registerUser } from '../../services/api';
import { AuthContext } from '../../contexts/AuthContext';
import routes from '../../utils/routes';
import logo from '../../assets/images/full_logo_color.svg';

function SignupForm() {
  const { login } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    phone: '',
    cuit: '',
    location: '',
    password: '',
    company: '',
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await registerUser(formData);
      login(data.token, data.user);
      showToast('success', 'Registrado correctamente');
      window.location = routes.home;
    } catch (error) {
      if (error.response) {
        showToast('error', 'Hubo un error creando su cuenta');
      } else {
        showToast('error', 'Error en el servidor');
      }
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="form-complete">
      <img src={logo} alt="logo-text" />
      <form onSubmit={handleSubmit}>
        <div className="form-fields">
          <div className="form-nexto">
            <input
              type="text"
              placeholder="Usuario"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required />
            <input
              type="text"
              placeholder="CUIT"
              name="cuit"
              onKeyPress={(e) => validateNumberInput(e)}
              onPaste={(e) => validateNumberInput(e)}
              maxLength="11"
              value={formData.cuit}
              onChange={handleChange}
              required />
          </div>
          <input
            type="email"
            placeholder="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required />
          <div className="password-container">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Contraseña"
              name="password"
              minLength="8"
              maxLength="128"
              value={formData.password}
              onChange={handleChange}
              required />
            <span className="material-symbols-outlined password-icon" onClick={togglePasswordVisibility}>
              {showPassword ? "visibility_off" : "visibility"}
            </span>
          </div>
          <input
            type="company"
            placeholder="Razón Social"
            name="company"
            value={formData.company}
            onChange={handleChange}
            required />
          <div className="form-nexto">
            <input
              type="text"
              placeholder="Ubicación"
              name="location"
              value={formData.location}
              onChange={handleChange}
              required />
          <input
            type="tel"
            placeholder="Teléfono"
            name="phone"
            maxlength="15"
            onKeyPress={(e) => validateNumberInput(e)}
            onPaste={(e) => validateNumberInput(e)}
            value={formData.phone}
            onChange={handleChange}
            required
            />
          </div>
          <button className="common-button" type="submit" disabled={loading}>
            {loading ? 'Creando cuenta...' : 'Registrarse'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default SignupForm;
// https://assets.justinmind.com/wp-content/uploads/2018/07/mint-sign-up-form.png